import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../../i18next';
import { getCurrencySymbol, transformProductPrice } from '../../../../../utils/CommonUtils';
import Pagination from 'react-js-pagination';
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGING_RANGE } from '../../../../../utils/Constants';
import { loadAdditionalChargesHistory } from '../../../../../actions';

class AdditionalChargesHistory extends Component {
    constructor(props) {
        super(props); 
    
        this.state = {
            additionalChargesHistory: {},
            currentPageNumber: 0
        }

        this.handlePageChange = this.handlePageChange.bind(this);
    }

    componentDidMount() {
        const restaurantId = this.props.match.params.id;

        this.props.loadAdditionalChargesHistory(restaurantId, 0);

        this.setState({
            additionalChargesHistory: this.props.restaurant.additionalChargesHistory
        })
    }

    handlePageChange(pageNumber) {
        const restaurantId = this.props.match.params.id;

        this.setState({
            currentPageNumber: (pageNumber - 1)
        }, () => this.props.loadAdditionalChargesHistory(restaurantId, this.state.currentPageNumber));
    }

    renderPagination() {
        const { flexEnd } = styles;
        const { additionalChargesHistory } = this.props.restaurant;

        return (
            <Col style={flexEnd}>
                <Pagination
                    activePage={additionalChargesHistory && additionalChargesHistory.content ? additionalChargesHistory.number + 1 : null}
                    itemsCountPerPage={DEFAULT_PAGE_SIZE}
                    totalItemsCount={additionalChargesHistory && additionalChargesHistory.content ? additionalChargesHistory.totalElements : null}
                    pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                    itemClass='page-item'
                    linkClass='page-link'
                    onChange={this.handlePageChange}
                />
            </Col>
        );
    }

    renderHeader() {
        const { headerStyle, spaceBetween } = this.props.styles;

        return (
            <div style={headerStyle}>
                <MaterialIcon icon="attach_money" color="#0288d1" size={20} />
                <span style={spaceBetween}>{i18n.t('screens:paymentScreen.additionalChargesHistory')}</span>
            </div>
        );
    }

    renderAdditionalChargesHistoryRows() {
        const { additionalChargesHistory } = this.props.restaurant;

        return additionalChargesHistory && additionalChargesHistory.content ? additionalChargesHistory.content.map((additionalChargeHistory, additionalChargeHistoryIndex) => {
           
            return (
                <Row key={additionalChargeHistoryIndex} style={{marginTop: '15px'}}>
                    <Col xs={2}>{additionalChargeHistory.restaurantId}</Col>
                    <Col xs={2}>{additionalChargeHistory.type}</Col>
                    <Col xs={2}>{additionalChargeHistory.name}</Col>
                    <Col xs={2}>{`${additionalChargeHistory.week} / ${additionalChargeHistory.year}`}</Col>
                    <Col xs={2}><span>{transformProductPrice(Number(additionalChargeHistory.amount))}</span><span>{getCurrencySymbol(this.props.restaurant.currency)}</span></Col>
                    <Col xs={2}>{additionalChargeHistory.createdDate}</Col>
                </Row>
            )
        }) : null
    }

    renderAdditionalChargesHistory() {
        return (
            <Col style={{ padding: '0px 0px 5px 0px', marginTop: '20px', textAlign: 'center' }}>
                <Row>
                    <Col xs={2}>{i18n.t('screens:paymentScreen.restaurantId')}</Col>
                    <Col xs={2}>{i18n.t('screens:paymentScreen.type')}</Col>
                    <Col xs={2}>{i18n.t('screens:paymentScreen.name')}</Col>
                    <Col xs={2}>{i18n.t('screens:paymentScreen.period')}</Col>
                    <Col xs={2}>{i18n.t('screens:paymentScreen.total')}</Col>
                    <Col xs={2}>{i18n.t('screens:paymentScreen.invoiceDate')}</Col>
                </Row>
            {this.renderAdditionalChargesHistoryRows()}
            {this.renderPagination()}
            </Col>
        )
    }

    render() {
        return (
            <div>
                {this.renderHeader()}
                {this.renderAdditionalChargesHistory()}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        restaurant: state.restaurant
    }
}

export default connect(mapStateToProps, { loadAdditionalChargesHistory })(AdditionalChargesHistory);

const styles = {
    flexEnd: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '30px',
        paddingRight: 0
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/restaurant/menuuBilling/AddittionalChargesHistory.js